import {html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {repeat} from 'lit/directives/repeat.js';
import {when} from 'lit/directives/when.js';
import {classMap} from 'lit/directives/class-map.js';
import {
	AttributeInterpreter,
	AttributeType,
	ChoiceValueDecisionState,
	ComponentDecisionState,
	ConfigurationInterpreter,
	DecisionKind
} from '@viamedici-spc/configurator-ts';

import {SpcBaseAttribute} from './spcBaseAttribute';
import {attributeIdToString} from './util/spcUtils';
import {staggeredReveal} from '../../css/styleSets';
import {attributeWidget} from '../../css/attributeWidget';
import info from '../../../icons/info';
import reset from '../../../icons/reset';
import radio from '../../../icons/radio';
import radioChecked from '../../../icons/radio-checked';

@customElement('spc-component-attribute')
export class SpcComponentAttribute extends SpcBaseAttribute {

	static styles = [
		staggeredReveal,
		attributeWidget,
		css`
			:host {}
		`];

	stateChanged(state) {
		super.stateChanged(state);

		if (this.spcConfiguration) {
			this.attribute = ConfigurationInterpreter.getComponentAttribute(this.spcConfiguration, this.attributeId);
			if (this.attribute) {
				const selectedValue = this.attribute.decision?.state === ComponentDecisionState.Included
					? 'included'
					: this.attribute.decision?.state === ComponentDecisionState.Excluded
						? 'excluded' : '';
				this.isIncludedStatePossible = this.attribute.possibleDecisionStates.includes(ComponentDecisionState.Included);
				this.isExcludedStatePossible = this.attribute.possibleDecisionStates.includes(ComponentDecisionState.Excluded);
				this.excludedValue = {
					id: ComponentDecisionState.Excluded,
					name: 'excluded', //TODO: translate component value id
					isImplicit: this.attribute.decision?.state === ComponentDecisionState.Excluded && this.attribute.decision?.kind === DecisionKind.Implicit
				};
				this.includedValue = {
					id: ComponentDecisionState.Included,
					name: 'included', //TODO: translate
					isImplicit: this.attribute.decision?.state === ComponentDecisionState.Included && this.attribute.decision?.kind === DecisionKind.Implicit
				};

			} else {
				console.error('Component attribute not found with id', this.attributeId, this.spcConfiguration);
			}
		}
	}
	async resetDecision() {
		this.session.makeDecision({
			type: AttributeType.Component,
			attributeId: this.attribute.id,
			state: null
		});
	}
	isSatisfied() {
		return this.attribute?.isSatisfied ?? false;
	}
	render() {
		return html`
			<div class="attribute ${classMap({satisfied: this.isSatisfied()})}">
				<div class="title">
					<div class='icon indicator'>${this.isSatisfied() ? radioChecked : radio}</div>
					<span class="label">${attributeIdToString(this.attributeId)}</span>
					<div class="tools">
						<button class='tools_button' @click="${this.showInfo}"><span class="icon">${info}</span></button>
						<button class='tools_button' @click="${this.resetDecision}"><span class="icon">${reset}</span></button>
					</div>
				</div>
				<div class="values">
					<spc-component-value
						.attributeId=${this.attributeId}
						.value=${this.includedValue}
						.hideDisabled=${this.hideDisabled}
						.productData=${this.getProductDataForValue(this.includedValue.id)}>
					</spc-component-value>
					<spc-component-value
						.attributeId=${this.attributeId}
						.value=${this.excludedValue}
						.hideDisabled=${this.hideDisabled}
						.productData=${this.getProductDataForValue(this.excludedValue.id)}>
					</spc-component-value>
				</div>
			</div>

		`;
	}
}
